module.exports = __webpack_public_path__ + "static/SearchVideoMobilePR-ed760ac9c2ddd3d94d057ab27ba144fb.mp4";